<template>
    <div class="person-light flex-row ai-center">
        <template v-if="isBlockedOrDeleted(person)">
            <div class="person-light-disabled__container fs-2 flex-row">
                <CompassIcon
                    :type="blockedOrDeletedType"
                    size="extra-small"
                    icon="lock-fill"
                    class="mr-1 person-light-disabled__icon"
                ></CompassIcon>
                <span
                    class="gray-80 person-light-disabled__label"
                    :class="{ strike: isDeleted(person), red: isDeleted(person) }"
                >
                    {{ getName }}
                </span>
                <span class="gray-60 ml-2">({{ blockedOrDeletedLabel }})</span>
            </div>
        </template>
        <template v-else>
            <CompassUser
                :lastname="getName"
                size="extra-small"
                class="person-light-avatar__container"
                @click="getUrlPerson()"
            >
                <CompassAvatar
                    :initials="getInitials"
                    :photo="getPhoto"
                    :colorType="avatarColor(getName)"
                />
            </CompassUser>
        </template>
    </div>
</template>
<script>
import AvatarMixins from 'mixins/AvatarMixins';
import { goToUrl } from 'js/vue/helpers.js';

export default {
    mixins: [AvatarMixins],
    props: {
        person: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
    },
    computed: {
        blockedOrDeletedLabel() {
            return this.isDeleted(this.person)
                ? this.$l10n.__(`${this.label} supprimé`)
                : this.$l10n.__(`${this.label} bloqué`);
        },

        getName() {
            return this.person.fullName ? this.person.fullName : this.person.name;
        },
        getInitials() {
            let name;
            if (this.person.avatar) {
                name = this.person?.avatar?.type === 'initials' ? this.person.avatar.value : '';
            } else {
                name = this.person.fullName[0];
            }
            return name;
        },
        getPhoto() {
            return this.person?.avatar?.type === 'picture' ? this.person.avatar.value : '';
        },
        blockedOrDeletedType() {
            return this.isDeleted(this.person) ? 'alert' : 'primary';
        },
    },
    methods: {
        goToUrl,
        getUrlPerson() {
            let url = false;
            const person = this.person;
            if (!this.isBlockedOrDeleted(person)) {
                if (person.url) {
                    url = person.url;
                } else if (person.link) {
                    url = person.link;
                } else {
                    switch (person.type) {
                        case 'people':
                            url = this.$router.resolve({
                                name: 'legacy.people.overview',
                                params: { id: person.peopleid },
                            }).href;
                            break;
                        case 'third':
                            url = this.$router.resolve({
                                name: 'legacy.third.overview',
                                params: { thirdid: person.thirdid, thirdtype: person.relationType },
                            }).href;
                            break;
                        case 'staff':
                            url = this.$router.resolve({
                                name: 'legacy.staff.overview',
                                params: { staffid: person.staffid },
                            }).href;
                            break;
                    }
                }
                if (url) {
                    this.goToUrl(url);
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.person-light-avatar__container::v-deep {
    .compass-user__name {
        cursor: pointer;
        color: $gray-80;
        font-size: 12px;
        line-height: 16px;
        font-weight: 700;
    }
    &:not(is-disabled) .compass-user__name:hover {
        color: $gray-100;
    }
}
.person-light-disabled {
    &__container span {
        line-height: 16px;
    }
    &__label {
        color: $gray-80;
        font-weight: 600;
    }

    &__icon {
        cursor: default;
    }
}
</style>
